import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropeListData } from "Pages/AutoEuropeTool/Page/@signals"

export default function useAutoEuropeActions() {
	const { showToast } = useToast()

	const onDisable = useCallback((id, name) => {
		showToast.confirm(`Are you sure you want to disable '${name}'?`, {
			onSubmit: () => showToast.promise(
				postSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/disable`, { id }),
				{
					onSuccess: (result) => {
						autoEuropeListData.value = autoEuropeListData.value.map(item =>
							item.id === id ? result : item
						)
					},
				}
			)
		})
	}, [])

	const onDelete = useCallback((id, name) => {
		showToast.confirm(`Are you sure you want to delete '${name}'? This action cannot be undone.`, {
			onSubmit: () => showToast.promise(
				postSubmit(`${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/delete`, { id }),
				{
					onSuccess: () => {
						autoEuropeListData.value = autoEuropeListData.value.filter(item => item.id !== id)
					},
				}
			)
		})
	}, [])

	return { onDisable, onDelete }
}